import { hubAPI } from '@/lib/api';

// Un échec après création du message réutilise son ID, sans republier le texte.
export async function sendProjectVoiceDraft({ projectId, draft, content, mentions, pending, onProgress }) {
    const file = draft.file;
    if (pending.messageId) {
        const { data } = await hubAPI.listProjectWall(projectId);
        const existing = data.find(message => message.id === pending.messageId);
        if (!existing) pending.messageId = null;
        // La réponse d'un upload peut s'être perdue après sa réception serveur.
        if (existing?.attachments?.some(a => a.original_filename === file.name && a.file_size === file.size)) return existing;
    }
    if (!pending.messageId) {
        const { data } = await hubAPI.createProjectWallMessage(projectId, content, mentions, { skipRetry: true });
        pending.messageId = data.id;
    }
    const { data } = await hubAPI.uploadProjectWallAttachment(projectId, pending.messageId, file, onProgress, { skipRetry: true });
    return data;
}